export default __webpack_public_path__ + "static/media/ahorros_de_hasta_mensuales.26bfa4c5.png";